module.exports = __webpack_public_path__ + "static/scopriabitareco_experiences_costruzionirealizzate-ffd86e5ffea8e05fca52ec50f9e0c0c5.jpg";